interface ConnectionStatusProps {
  status: 'connecting' | 'connected' | 'disconnected' | 'error';
}

/**
 * Displays a banner at the top of the screen when the socket is not connected.
 * Hidden when status is 'connected'.
 */
export function ConnectionStatus({ status }: ConnectionStatusProps) {
  if (status === 'connected') return null;

  return (
    <div
      style={{
        padding: '6px 16px',
        fontSize: '0.8rem',
        textAlign: 'center',
        background: status === 'error' ? '#c0392b' : '#e8a020',
        color: '#fff',
      }}
    >
      {status === 'connecting'
        ? 'Connecting to live updates…'
        : 'Disconnected — scores may not sync'}
    </div>
  );
}
